import {css} from 'styled-components'

export const bannerTitle = css`
    font-family: ${(props) => props.theme.fonts.headline[200].fontFamily};
    font-weight: light;
    margin: 0;
`

export const bannerWrapper = css`
    img {
        transition: transform 2.2s cubic-bezier(0.14, 1.12, 0.67, 0.99) 0s;
    }

    h2 {
        transition: color 2.2s cubic-bezier(0.14, 1.12, 0.67, 0.99) 0s;
    }

    &:hover {
        img {
            transform: scale(1.03);
        }

        h2 {
            color: ${(props) => props.theme.colors.content.secondary};
        }
    }
`
